import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import API from './plugins/API'
import BUS from './plugins/BUS'
import VueI18n from 'vue-i18n' // 1. Importamos la librer�a de traducci�n

// 2. Registramos el plugin en Vue
Vue.use(VueI18n)
Vue.use(API)
Vue.use(BUS)

Vue.config.productionTip = false

// 3. Creamos la instancia de i18n con una configuraci�n b�sica por defecto
const i18n = new VueI18n({
    locale: 'es', // Idioma por defecto (coincidiendo con las clases CSS en espa�ol de tu app)
    fallbackLocale: 'es',
    messages: {
        es: {
            // Aqu� puedes a�adir tus traducciones si las necesitas en el futuro
        }
    }
})

new Vue({
    router,
    vuetify,
    i18n, // 4. Inyectamos i18n en la instancia de Vue para que est� disponible globalmente
    render: h => h(App)
}).$mount('#app')
